import { Box, Flex, Stack } from '@chakra-ui/react';
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import SegmentedControl from 'components/segmented-control';
import { RType } from 'routes/types';
import { useAdminSidebarMode } from '../hooks/useAdminSidebarMode';
import { translate } from '../../../i18n';

const SIDEBAR_MODE_OPTIONS = [
	{ id: 'focused', label: '' },
	{ id: 'full', label: '' },
];

function SidebarContent(props: { routes: RType[]; enableFavorites?: boolean }) {
	const { routes, enableFavorites } = props;
	const { mode, setMode } = useAdminSidebarMode();

	// Compute labels at render time so translations are resolved
	const modeOptions = SIDEBAR_MODE_OPTIONS.map((opt) => ({
		...opt,
		label: translate(`sidebar.${opt.id}` as any) || opt.id,
	}));

	return (
		<Flex direction='column' height='100%' pt='25px' borderRadius='30px'>
			<Brand />
			{enableFavorites && (
				<Flex px='20px' mt='8px' mb='4px' justify='center' data-tour='sidebar-mode'>
					<SegmentedControl
						options={modeOptions}
						selectedId={mode}
						onChange={(id) => setMode(id as 'focused' | 'full')}
					/>
				</Flex>
			)}
			<Stack direction='column' mt='8px' mb='auto'>
				<Box ps='20px' pe={{ lg: '16px', '2xl': '16px' }} pb='24px'>
					<Links
						routes={routes}
						enableFavorites={enableFavorites}
						sidebarMode={enableFavorites ? mode : undefined}
						onSwitchMode={enableFavorites ? setMode : undefined}
					/>
				</Box>
			</Stack>
		</Flex>
	);
}

export default SidebarContent;
